<template>
  <div>
    <a href="javacript:void(0);" class="font-color-lighter">
      <i class="material-icons align-middle font-3lg">attachment</i>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attachment: null,
    };
  },
  beforeMount() {
    this.attachment = this.params.data.attachment;
  }

};
</script>
